import { ContactTypeEnum, UserTagEnum } from 'src/services/GraphQL';
import { TSelectField } from 'src/libs/ui-kit';
import { PlatformAdminApi } from 'src/services/GrpcService/codegen/app_pb';
import { Variant } from 'react-bootstrap/esm/types';
import { USER_TAGS } from '../widgets';

export enum CUSTOMERS_PROVIDER_TOKENS {
  CUSTOMERS_SERVICE = 'customersService',
}

export const addressTypeOptions = [
  { id: PlatformAdminApi.ADDRESS_TYPE.DEFAULT, title: 'Создан пользователем' },
  { id: PlatformAdminApi.ADDRESS_TYPE.RESIDENCE_ADDRESS, title: 'Проживание' },
];

export const BLOCKING_REASON_OPTIONS: TSelectField<PlatformAdminApi.BLOCKING_REASON_SLUG>[] = [
  {
    label: 'Любой статус',
    name: PlatformAdminApi.BLOCKING_REASON_SLUG.UNDEFINED_BLOCKING_REASON_SLUG,
  },
  {
    label: 'Отзыв разрешения на обработку перс. данных',
    name: PlatformAdminApi.BLOCKING_REASON_SLUG.REVOCATION_PERS_DATA,
  },
  {
    label: 'Окончание сотрудничества',
    name: PlatformAdminApi.BLOCKING_REASON_SLUG.END_COOPERATION,
  },
];

export const CONTACT_NAMES_BY_TYPE_MAP = {
  [ContactTypeEnum.FACEBOOK]: 'Facebook',
  [ContactTypeEnum.INSTAGRAM]: 'Instagram',
  [ContactTypeEnum.LINKED_IN]: 'LinkedIn',
  [ContactTypeEnum.OK]: 'OK',
  [ContactTypeEnum.TELEGRAM]: 'Telegram',
  [ContactTypeEnum.TWITTER]: 'Twitter',
  [ContactTypeEnum.VK]: 'VK',
} as const;

export const USER_TAGS_BADGES: Record<USER_TAGS, Variant> = {
  [USER_TAGS.VIP]: 'dark',
};

export const USER_TAG_MAP: Record<UserTagEnum, USER_TAGS> = {
  [UserTagEnum.TAG_VIP]: USER_TAGS.VIP,
};

export const USER_TAG_TO_API_MAP: Record<USER_TAGS, UserTagEnum> = {
  [USER_TAGS.VIP]: UserTagEnum.TAG_VIP,
};
